import axios from 'axios';

const API = process.env.VUE_APP_BASE_URI;

export default {
    addUser({
        commit
    }, user_data) {
        return new Promise((resolve, reject) => {
            let url = user_data.mode && user_data.mode === 'edit' ? `${API}/user/${user_data.id}` : `${API.replace("api/", "")}/register`;
            let axiosCall = user_data.mode && user_data.mode === 'edit' ? axios.put(url, user_data) : axios.post(url, user_data);
            axiosCall.then(({
                    data
                }) => {
                    resolve(data);
                })
                .catch(error => reject(error.response))
        })
    },
    getUsers({
        commit
    }) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/users`)
                .then(({
                    data
                }) => {
                    commit("SET_USERS", data);
                    resolve(data)
                }).catch(error => reject(error.response))
        })
    },
    getUsersTotal({
        commit
    }) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/user`)
                .then(({
                    data
                }) => {
                    resolve(data.total)
                }).catch(error => reject(error.response))
        })
    },
    getUser({
        commit
    }, user_id) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/user/${user_id}`)
                .then(({
                    data
                }) => {
                    resolve(data)
                }).catch(error => reject(error.response))
        })
    },
    getUserPermissions({
        commit
    }, user_id) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/user/${user_id}/permissions`)
                .then(({
                    data
                }) => {
                    resolve(data)
                }).catch(error => reject(error.response))
        })
    }

}